const cleanupStarted = new WeakSet()

export function disposeTooltip(instance) {
  if (!instance || cleanupStarted.has(instance) || instance._element === null) return
  cleanupStarted.add(instance)

  // Bootstrap 5.3 queues show/hide completion on the fading tip, but dispose()
  // does not cancel that callback and instead nulls fields it still reads. The
  // queue API is private and returns no cancellation handle, so finish the same
  // public transitionend Bootstrap would synthesize before disposing. This is
  // deliberately isolated here and covered against the installed Bootstrap.
  if (instance.tip?.classList.contains("fade")) {
    instance.tip.dispatchEvent(new Event("transitionend"))
  }

  instance.dispose()
}
